import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { UpgradeTeamModalContent } from './UpgradeTeamModalContent';

export const UpgradeTeamModal = () => {
  return (
    <AppModal
      modalName={Modals.UPGRADE_TEAM}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs">
      <UpgradeTeamModalContent />
    </AppModal>
  );
};
